import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';
import { ImpersonationBanner } from '@/features/admin/components/ImpersonationBanner';
import { AppLayout } from './AppLayout';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

export function ProtectedLayout({ children }: ProtectedLayoutProps) {
  return (
    <ProtectedRoute>
      <>
        <ImpersonationBanner />
        <AppLayout>{children}</AppLayout>
      </>
    </ProtectedRoute>
  );
}
